import React, { useEffect, useState } from "react";
import LineSelect from "./LineSelect";
import "./CountrySelect.css";

const COUNTRIES_URL = "https://countriesnow.space/api/v0.1/countries/iso";

async function loadCountryNames() {
  const response = await fetch(COUNTRIES_URL);
  if (!response.ok) throw new Error("Countries could not be loaded.");
  const payload = await response.json();
  const rows = Array.isArray(payload?.data) ? payload.data : [];
  return rows
    .map((country) => String(country?.name || "").trim())
    .filter(Boolean)
    .sort((left, right) => left.localeCompare(right));
}

export default function CountrySelect({ value, onChange, onReady }) {
  const [countries, setCountries] = useState([]);
  const [status, setStatus] = useState("loading");
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    let active = true;
    setStatus("loading");
    loadCountryNames()
      .then((names) => {
        if (!active) return;
        setCountries(names);
        setStatus(names.length ? "ready" : "error");
      })
      .catch(() => {
        if (active) setStatus("error");
      });
    return () => {
      active = false;
    };
  }, [attempt]);

  useEffect(() => {
    onReady?.(status);
  }, [onReady, status]);

  return (
    <div className="country-select">
      <LineSelect
        value={value}
        placeholder={status === "loading" ? "Loading countries…" : "Select a country"}
        disabled={status !== "ready"}
        options={countries.map((name) => ({ value: name, label: name }))}
        onChange={onChange}
      />
      {status === "error" ? (
        <p className="country-select__status">
          Countries could not be loaded.
          <button type="button" className="country-select__retry" onClick={() => setAttempt((current) => current + 1)}>
            Try again
          </button>
        </p>
      ) : null}
    </div>
  );
}
